import { faChartBar, faHome, faTag, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import BottomNavigation from 'reactjs-bottom-navigation';
import 'reactjs-bottom-navigation/dist/index.css';

const nav = ['/', '/insights', '/marketprice-db', '/dashboard/profile'];

const items = [
  {
    title: 'Home',
    icon: <FontAwesomeIcon icon={faHome} />,
    activeIcon: <FontAwesomeIcon style={{ color: '#0056b3' }} icon={faHome} />,
  },
  {
    title: 'Insights',
    icon: <FontAwesomeIcon icon={faChartBar} />,
    activeIcon: <FontAwesomeIcon style={{ color: '#0056b3' }} icon={faChartBar} />,
  },
  {
    title: 'Marketprice',
    icon: <FontAwesomeIcon icon={faTag} />,
    activeIcon: <FontAwesomeIcon style={{ color: '#0056b3' }} icon={faTag} />,
  },
  {
    title: 'Profile',
    icon: <FontAwesomeIcon icon={faUser} />,
    activeIcon: <FontAwesomeIcon style={{ color: '#0056b3' }} icon={faUser} />,
  },
];

const BottomNav = ({ history }) => {
  const [url, setUrl] = useState(nav.findIndex((item) => item === history.location.pathname));

  useEffect(() => {
    setUrl(nav.findIndex((item) => item === history.location.pathname));
  }, []);

  return (
    <div className="d-lg-none d-md-none">
      <BottomNavigation
        items={items}
        defaultSelected={url}
        activeBgColor={'rgba(255, 255, 255, 0)'}
        activeTextColor={'#0056b3'}
        onItemClick={(item) => {
          history.push(nav[item.id]);
        }}
      />
    </div>
  );
};

export default BottomNav;
